import { useMemo } from "react";
import useGetGreetingMessage from "../../../../../Hooks/useGetGreetingMessage";
import { cleanText, extractPatterns, parseSuggestions } from "../utils";

const ChatbotGreetingMessage = ({ onSelect }) => {
  const { data } = useGetGreetingMessage({ enabled: true });

  const { patterns, title, description } = useMemo(() => {
    const answer = data?.greetingMessage || "";

    const patterns =
      parseSuggestions(extractPatterns(answer)?.SUGGESTIONS) || [];
    const cleanedText = cleanText(answer);
    const title = cleanedText.split("\n")?.[0]?.trim() || "";
    const description = cleanedText.split("\n")?.[1]?.trim() || "";

    return {
      patterns,
      title,
      description,
    };
  }, [data]);

  return (
    <div className="chatbot-greeting-message-wrapper">
      <div className="title">{title}</div>
      <div className="description">{description}</div>

      <div className="chips-wrapper">
        {patterns?.map((chip, index) => (
          <div key={index} className="chip" onClick={() => onSelect(chip)}>
            {chip}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatbotGreetingMessage;
